import { yupResolver } from '@hookform/resolvers/yup';
import { CircularProgress, Container, Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { GET_USER_BY_ID, UPDATE_USER } from 'src/apiService/apiDeclaration';
import CustomTextField from 'src/components/formFields/textField';
import LoaderButton from 'src/components/loaderButton/loaderButton';
import { signUpSchema } from 'src/config/yup';
import { showErrorTost, showSuccessTost } from 'src/constants';

const Profile = () => {
  const { user } = useSelector((state) => state.auth);
  const [userData, setUserData] = useState();
  const [loading, setLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);

  const {
    control,
    reset,
    handleSubmit,
    formState: { errors, isValid, isDirty },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(signUpSchema.omit(['password', 'confirmPassword'])),
    defaultValues: userData?.email && {
      ...userData,
    },
  });

  const getUser = async () => {
    setLoading(true);
    try {
      let resp = await GET_USER_BY_ID(user._id);
      let fetchedUserData = resp.data;
      setUserData(fetchedUserData);
      reset({
        ...fetchedUserData,
      });
    } catch (error) {
      console.log(error);
      showErrorTost(error.message);
    } finally {
      setLoading(false);
    }
  };

  const updateUser = async (body) => {
    setUpdateLoading(true);
    try {
      let resp = await UPDATE_USER(user._id, body);
      setUserData(resp.data);
      showSuccessTost(resp.message);
    } catch (error) {
      showErrorTost(error.message);
    } finally {
      setUpdateLoading(false);
    }
  };

  useEffect(() => {
    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? (
        <Container
          sx={{ height: '60vh', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <CircularProgress />
        </Container>
      ) : (
        <Container>
          <form onSubmit={handleSubmit(updateUser)}>
            <Grid item xs={12}>
              <Typography variant={'h3'}>
                {userData?.firstName} {userData?.lastName}
              </Typography>
              <Grid container xs={12} spacing={4} mt={2}>
                <Grid item xs={12} sm={6}>
                  <CustomTextField
                    label={t('common.fName')}
                    controller={{
                      name: 'firstName',
                      control: control,
                      errors: errors.firstName,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomTextField
                    label={t('common.lName')}
                    controller={{
                      name: 'lastName',
                      control: control,
                      errors: errors.lastName,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomTextField
                    label={'Email'}
                    controller={{
                      name: 'email',
                      control: control,
                      errors: errors.email,
                    }}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomTextField
                    label={t('common.phone')}
                    controller={{
                      name: 'phoneNumber',
                      control: control,
                      errors: errors.phoneNumber,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomTextField
                    label={t('common.stAddress')}
                    controller={{
                      name: 'streetAddress',
                      control: control,
                      errors: errors.streetAddress,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomTextField
                    label={t('common.stNo')}
                    controller={{
                      name: 'streetNumber',
                      control: control,
                      errors: errors.streetNumber,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomTextField
                    label={t('signupPage.reference')}
                    controller={{
                      name: 'reference',
                      control: control,
                      errors: errors.reference,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomTextField
                    label={t('common.municipality')}
                    controller={{
                      name: 'municipality',
                      control: control,
                      errors: errors.municipality,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomTextField
                    label={t('common.city')}
                    controller={{
                      name: 'city',
                      control: control,
                      errors: errors.city,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomTextField
                    label={t('common.country')}
                    controller={{
                      name: 'country',
                      control: control,
                      errors: errors.country,
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container xs={12}>
                <Grid item xs={6} sm={4} my={3}>
                  <LoaderButton
                    loading={updateLoading}
                    buttonText={t('common.update')}
                    type={'submit'}
                    disabled={!isValid || !isDirty}
                  />
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Container>
      )}
    </>
  );
};

export default Profile;
